import { RadioGroupComponent } from '@app/form-builder/components/control-elements/radio-group/radio-group.component';
import { FileUploadComponent } from '@app/form-builder/components/control-elements/file-upload/file-upload.component';
import { DynamicComponent } from '@app/form-builder/components/container-elements/dynamic/dynamic.component';
import { TextComponent } from '@app/form-builder/components/control-elements/text/text.component';
import { CheckboxGroupComponent } from '@app/form-builder/components/control-elements/checkbox-group/checkbox-group.component';
import { SectionTableComponent } from '@app/form-builder/components/container-elements/table/table.component';
import { ButtonComponent } from '@app/form-builder/components/control-elements/button/button.component';
import { CardComponent } from '@app/form-builder/components/container-elements/card/card.component';
import { ControlsFabricComponent } from '@app/form-builder/components/controls-fabric/controls-fabric.component';
import { ContainersFabricComponent } from '@app/form-builder/components/containers-fabric/containers-fabric.component';
import { SectionComponent } from '@app/form-builder/components/container-elements/section/section.component';
import { FormComponent } from '@app/form-builder/components/layout-elements/layout/form.component';
import { TextAreaComponent } from '@app/form-builder/components/control-elements/text-area/text-area.component';
import { SelectComponent } from '@app/form-builder/components/control-elements/select/select.component';
import { InputComponent } from '@app/form-builder/components/control-elements/input/input.component';
import { SearchComponent } from '@app/form-builder/components/control-elements/search/search.component'
import { MultiSelectComponent } from '@app/form-builder/components/control-elements/multi-select/multi-select.component'
import { TimePickerComponent } from '@app/form-builder/components/control-elements/timepicker/timepicker.component'
import { ImageGroupComponent } from '@app/form-builder/components/control-elements/image-group/image-group.component'

import { SanitizeInputPipe } from '@app/core/pipes/sanitizar-text.pipe'
import { FormBuilderComponent } from '@app/form-builder/form-builder.component'
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ConfirmationPopoverModule } from 'angular-confirmation-popover'
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker'

import { cardRightDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/card-right/card-right.component'
import { cardTopDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/card-top/card-top.component'
import { tableDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table/table.component'
import { tableFormDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table-form/table-form.component'
import { tableTopDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table-top/table-top.component'
import { tableTopHallazgosDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table-top-hallazgos/table-top-hallazgos.component'
import { tableTopReplyDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table-top-reply/table-top-reply.component'
import { tableTopSubstancesDynamicComponent } from '@app/form-builder/components/control-dynamic-elements/table-top-substances/table-top-substances.component'

@NgModule({
  declarations: [
    FormBuilderComponent, 
    FormComponent, 
    InputComponent, 
    SelectComponent, 
    TextAreaComponent,  
    SectionComponent, 
    ContainersFabricComponent, 
    ControlsFabricComponent, 
    CardComponent, 
    ButtonComponent, 
    SectionTableComponent, 
    CheckboxGroupComponent, 
    TextComponent, 
    DynamicComponent, 
    FileUploadComponent, 
    RadioGroupComponent,
    SearchComponent,
    MultiSelectComponent,
    TimePickerComponent,
    ImageGroupComponent,

    cardRightDynamicComponent,
    cardTopDynamicComponent,
    tableDynamicComponent,
    tableFormDynamicComponent,
    tableTopDynamicComponent,
    tableTopHallazgosDynamicComponent,
    tableTopReplyDynamicComponent,
    tableTopSubstancesDynamicComponent,

    SanitizeInputPipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxReactiveFormsModule,
    ConfirmationPopoverModule.forRoot({
      confirmButtonType: 'danger'
    }),
    NgbModule,
    NgSelectModule,
    NgxMaterialTimepickerModule.setLocale('es'),
  ],
  exports: [FormBuilderComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FormBuilderModule { }
